<template>
    <div>
        <single :type="type" :productKey="productKey"  v-if="isShowSingle" @back="back" />
        <Bundle :type="type" :productKey="productKey" v-if="isShowBundle"  @back="back"/>
        <any :type="type" :productKey="productKey" v-if="isShowAny" @back="back" />

    </div>
</template>

<script>
import single from './edit/single'
import Bundle from './edit/bundle'
import any from './edit/any'
    export default {
        name: 'Edit',
        props: {
            type: Number,
            productKey: String
        },
        components: {
            single,
            Bundle,
            any
        },
        data() {
            return {
                isShowSingle: false,
                isShowBundle: false,
                isShowAny: false
            }
        },
        methods: {
            back(){
                this.$emit('back')
            },
            checkType(){
                if (this.type  == 1) {
                    this.isShowSingle = true
                    this.isShowBundle = false
                    this.isShowAny = false

                } else if(this.type == 2) {
                     this.isShowSingle = false
                    this.isShowBundle = true
                    this.isShowAny = false
                } else if (this.type == 3){
                       this.isShowSingle = false
                    this.isShowBundle = false
                    this.isShowAny = true
                }
            }
        },
        created() {
            this.checkType()
        },
    }
</script>

<style lang="scss" scoped>
    
</style>